import * as React from 'react';
import { M3_LOGO } from '../navigation/Constants';

type Props = {
};

type States = {
};

class EmailNotVerifiedComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
    };
  }

  render() {
    return(
      <div
        style={{backgroundColor: '#43464e', height: '100vh'}}
      >
        <div
          className="row justify-content-center align-items-center"
          style={{height: '100vh'}}
        >
          <div
            className="col-8"
          >
            <div className="row justify-content-center mt3 mb3">
              <div className="col-4">
                <img
                  id="sidebar_m3_logo"
                  src={M3_LOGO}
                  alt="M3_Logo"
                  title="M3_Logo"
                />
              </div>
            </div>
            <div className="row justify-content-center mt3 mb3">
              <div className="col-12">
                <h1
                  style={{
                    color: 'white',
                    textAlign: 'center'
                  }}
                >
                  Email Address Verification Failure
                </h1>
              </div>
            </div>
            <div className="row mt3">
              <div className="col-12">
                <h3
                  style={{
                    color: 'white',
                    textAlign: 'center'
                  }}
                >
                  We're sorry, but Mimosa Solutions could not verify your email address.
                  You will not be able to send email to or from M3 until it is verified.
                  Please contact cs@mimosa.solutions or 1-833-597-5554
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailNotVerifiedComponent;



// WEBPACK FOOTER //
// ./src/commons/EmailNotVerifiedComponent.tsx